export default __webpack_public_path__ + "dcfece2e53a78c097f16d79c6e69cf37.png";